import * as React from "react";
import { styled } from "@mui/system";
import MUITableCell from "@mui/material/TableCell";
import { TableCellProps as TableCellPropsMUI } from "@mui/material/TableCell";

export interface TableCellProps extends TableCellPropsMUI {
  borderBottom?: boolean;
}

export const TableCell: (props: TableCellProps) => JSX.Element = styled(
  React.forwardRef<HTMLTableCellElement, TableCellProps>((props, ref) => (
    <MUITableCell ref={ref} {...props} />
  )),
  {
    name: "TableCell",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "borderBottom" && prop !== "myProp",
    overridesResolver: (props, styles) => []
  }
)(({ theme, borderBottom }) => ({
  "&.MuiTableCell-root": {
    borderBottom:
      borderBottom === false
        ? "none"
        : "1px solid " + theme.palette.primary.borderDefault
  }
}));
